import { Link } from "gatsby";
import React from "react";
import { slug } from "../slug";

export default function Top({ data }) {
  return (
    <div className="header-top-bar top-bar-one yellow-bg">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-xl-12 col-lg-12 col-md-12 col-12">
            <div className=" d-flex align-items-center justify-content-center">
              {/* <Link to={slug(data?.link1)}>
                <span className="text">{data?.welcome}</span>
              </Link> */}
              {data?.time && (
                <a href={data?.link2} target="_blank">
                  <span className="text text-lg font-bold text-dark">
                    {/* <i className="far fa-clock" /> */}
                    {data?.time}
                  </span>
                </a>
              )}
            </div>
          </div>
          {/* <div className="col-xl-2 col-lg-2 col-md-2 col-6">
            <div className="top-bar-right d-flex align-items-center justify-content-end">
              <ul className="social-link">
                {data?.social.map((item, index) => (
                  <li key={index}>
                    <a href={item.url} target="_blank">
                      <i className={`fab ${item.icon}`} />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
}
